import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useCommentInquiry from './hooks/useCommentInquiry';

interface Params {
    inquiryId: string;
    content: string;
    fileUrls: string[];
}

const InquiryCommentModal: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { inquiryId, content, fileUrls } = params;
  const { closeBottomSheet } = useBottomSheet();
  const { pop } = useFlow();
  const handleCommentInquiry = useCommentInquiry(inquiryId);
  return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={32}>
                    <Column fullWidth align='center' spacing={8}>
                        <Text size='3xl' fontWeight='bold'>
                            이대로 문의를 남길까요?
                        </Text>
                        <Text color={colors.gray6}>
                            등록 후 수정이 불가합니다.
                        </Text>
                    </Column>
                    <Row fullWidth spacing={10}>
                        <Button variant='secondary' fullWidth onClick={pop} noPadding>
                            취소
                        </Button>
                        <Button fullWidth
                                noPadding
                                onClick={() => {
                                  // pop();
                                  closeBottomSheet();
                                  handleCommentInquiry(content, fileUrls);
                                }}>
                            등록
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default InquiryCommentModal;
